<template>
  <v-row>
    <v-col cols="12">
        <staff-list-card> </staff-list-card> 
    </v-col>
  </v-row>
</template>
<script>
import StaffListCard from "@/components/staff/StaffListCard";

export default {
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Staff List",
  },

  components: {
    StaffListCard
  },

  data() {
    return {
    };
  },
};
</script>